module.exports = __webpack_public_path__ + "img/system.9764534f.svg";